<!-- 设备管理页面 -->
<template>
    <div class="campus-announcement">
        <div class="Input-Row-Top">
            <!-- <h1 class="shebeigunali">设备管理页面</h1> -->
            <el-form @keyup.native.enter="searchSouSuoClick">
            <el-row class="School-Effective">
                <el-col :span="6">
                    <el-form-item label="IMEI:" label-width="115px">
                    <el-input v-model="form.imei" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="RFID:" label-width="115px">
                    <el-input v-model="form.rfid" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="型号:" label-width="115px">
                    <el-input v-model="form.dictionaryName" placeholder=''></el-input>
                </el-form-item></el-col>
                <el-col :span="6">
                    <el-form-item label="姓名:" label-width="115px">
                    <el-input v-model="form.deviceName" placeholder=''></el-input>
                </el-form-item></el-col>
                <el-col :span="6">
                    <el-form-item label="统计：">
                     <el-select v-model="Tongji" filterable placeholder="请选择类型">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
          </el-form-item>
                  </el-col>
            </el-row>
            <el-row class="School-Effective">
                <el-col :span="6">
                    <el-form-item label="号码:" label-width="115px">
                    <el-input v-model="form.phoneNumber" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="服务IP:">
                    <el-input v-model="form.toIP" placeholder=''></el-input>
                </el-form-item>
                </el-col> -->
                <el-col :span="6">
                    <el-form-item label="版本号:" label-width="115px">
                    <el-input v-model="form.appVersion" placeholder=''></el-input>
                </el-form-item></el-col>
                <el-col :span="6">
                    <el-form-item label="所属用户:" label-width="135px">
                        <el-select  ref="selectYi" v-model="belongArea"  placeholder="请选择数据来源" @visible-change='visibleChange("查询")'>
                            <el-option :label="item.name" :value="item.id" v-for="item in belongAreaList" :key="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="蓝牙MAC:">
                    <el-input v-model="form.bluetoothMac" placeholder=''></el-input>
                </el-form-item></el-col> -->
                <el-col :span="6">
                    <el-form-item label="更多:" label-width="125px">
                        <el-select v-model="formSourcesValue"  placeholder="请选择数据来源"  >
                            <el-option label="其他" value="0"></el-option>
                            <el-option :label="item.name" :value="item.value" v-for="item in buttonData" :key="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-button size="medium" type="primary" class="searchBtn" @click="searchSouSuoClick" >查询</el-button>
                <el-button size="medium" type="danger" @click="deleteClick" class="shanchu">批量删除</el-button>
            </el-row>
        </el-form>

        </div>
        <div class="upload-box" v-if="  
            formSourcesValue == '2'||
            formSourcesValue == '3'||
            formSourcesValue == '5'
        ">
            <el-form-item label="所属用户："   >
                <el-select  ref="selectTo" v-model="theuserValue"  placeholder="请选择数据来源" @visible-change='visibleChange("导入")'>
                    <el-option :label="item.name" :value="item.id" v-for="item in leadingAreaList" :key="item.name"></el-option>
                </el-select>
            </el-form-item>
            <div class="upload-lef">
                <!-- <div @click="clickUpload">上传附件</div> -->
                <span class="upload-title">请选择要导入的数据文件：</span>
                <input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
                <el-button type="primary" @click="uploadClick">上传</el-button>
            </div>
        </div>
        <!-- table表格 -->
        <div class="Table-Bottom">
            <el-table
                height="650"
                stripe
                :border="true"
                v-loading="loading"
                :header-cell-style="{background:'#EDF6FF',color:'#000', height:'40px' ,}"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                @sort-change="sort_change"
                >
                <el-table-column
                type="selection"
                width="50px"
                >
              </el-table-column> 
              <el-table-column type="index" label="编号" width="65"></el-table-column>
                <el-table-column
                prop="deviceName"
                label="姓名"
                 width="150px"
                >
                </el-table-column>
                <el-table-column
                prop="imei"
                label="IMEI"
                
                >
                </el-table-column>
                <el-table-column
                prop="dictionaryName"
                label="型号"
                >
                </el-table-column>
             
                <el-table-column
                prop="phoneNumber"
                label="号码"
                
                >
                </el-table-column>
                <el-table-column
                prop="memberPhoneNumber"
                label="关联用户"
                
                >
                </el-table-column>
                <!-- <el-table-column
                label="最新记录消息"
                 width="550px"
                >
                <template #default="scope">
                   
                 
                    
                </template>

              </el-table-column> -->

                <el-table-column show-overflow-toolti    width="400px" >
                    <template #header >
                        <span @click="moren" >最新记录消息</span>
                        <ArrowDown v-if="!ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="downwardClick" />
                        <ArrowUp v-if="ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="upwardClick" />
                    </template>
                    <template #default="scope">
                        <!-- <p>{{ scope.row.lastAck }}</p> -->
                        <div v-if="scope.row.gpsEntity != null && scope.row.gpsEntity.addr1 != '[]'" class="jilumes">
                        <el-button  class="textBtn"  type="text" size="small" @click="locatingInfoC(scope.row)">定位</el-button>

                        <el-button  class="textBtn"  type="text" size="small" @click="WeiZhi(scope.row)">
                            {{scope.row.gpsEntity.addr1}}
                        </el-button>
                        <img src="./img/lotype1.png" v-if="scope.row.gpsEntity.type == 1" alt="" style="width: 20px; height: 20px;">
                            <img src="./img/lotype2.png" v-if="scope.row.gpsEntity.type == 2" alt="" style="width: 20px; height: 20px;">
                            <img src="./img/lotype4.png" v-if="scope.row.gpsEntity.type == 4"  alt="" style="width: 20px; height: 20px;">
                            <el-button  class="textBtn"  type="text" size="small" >
                            {{scope.row.gpsEntity.created}} 
                        </el-button>
                            <el-button  class="textBtn"  type="text" size="small" >电量:{{scope.row.bat}}%</el-button>
                            <el-button  class="textBtn"  type="text" size="small" >信号:{{scope.row.gpsEntity.gms}}%</el-button>
                            <el-button  class="textBtn"  type="text" size="small" >步数:{{scope.row.step}}</el-button>
                    <!-- <el-button  class="textBtn"  type="text" size="small" @click="WeiZhi(scope.row)">上海市天山路小学</el-button> -->
                   </div>
                   <div v-else >{{ '----' }}</div>
                    </template>
                </el-table-column>

                <el-table-column show-overflow-toolti  >
                    <template #header >
                        <span @click="moren" >最近活跃</span>
                        <ArrowUp v-if="ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="upwardClick" />
                        <ArrowDown v-if="!ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="downwardClick" />
                    </template>
                    <template #default="scope">
                        <p>{{ scope.row.lastAck }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                prop="appVersion"
                label="版本号"
                
                >
                </el-table-column>
                <el-table-column
                label="SIM卡状态"
                
                >
                <template #default="scope">
                    <el-button v-if="scope.row.iccidStatus == 0" >正常</el-button>
                    <el-button v-if="scope.row.iccidStatus == 1" >锁卡</el-button>
                </template>
                </el-table-column>
                <el-table-column
                label="终端状态"
                
                >
                <template #default="scope">
                    <el-button v-if="scope.row.disable == 0" @click="jinYong(scope.row)" :disabled="scope.row.iccidStatus==1?true:false">正常</el-button>
                    <el-button v-if="scope.row.disable == 1" @click="jinYong(scope.row)" :disabled="scope.row.iccidStatus==1?true:false">启用</el-button>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                width="130px"
                >
                <template #default="scope">
                    <el-select v-model="scope.row.addressValue" filterable placeholder="请选择数据来源" @change="addressClick(scope.row,scope.$index)">
                        <el-option label="请选择" value="0"></el-option>
                        <el-option :label="item.name" :value="item.value" v-for="item in scope.row.addressValueList" :key="item.name"></el-option>
                    </el-select>
                </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
                <!-- <el-button @click="toggleSelection()">批量删除</el-button> -->
            </div>
            <div class="block">
                <div class="total"> 共<span class="texttiao">{{total}}</span>条记录，当前显示<span class="texttiao">{{ twigMin }}</span>到<span class="texttiao">{{ twigMax }}</span>条</div>
                 <div class="">
                     <el-pagination
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         layout="prev, pager, next, jumper"
                         :page-size="pageInfo.pageSize"
                         :total="total">
                         </el-pagination>
                 </div>
             </div>
        </div>
       
        <Add v-if="AddShow" :detailsObj='detailsObj' @AddShowClick="AddShowClick"></Add>
        <Huanjiadd v-if="HuanjiShow" :HuanjiObj='HuanjiObj'  @HuanjiShowClick="HuanjiShowClick"></Huanjiadd>
        <Delete v-if="DeleteShow"  @closeClick="closeClick"></Delete>
        <userAreaDelete v-if="userAreaDelete" @handleClose='handleClose' @singleSelectionClick="singleSelectionClick"></userAreaDelete>
        <Qiehuan v-if="SwitchingShow"  @AddShowClick="AddShowClick"></Qiehuan>
        <MapInfo v-if="ShowMap" :mapObj='mapObj'  @cMapClick="cMapClick"></MapInfo>
        <LocatingInfo v-if="ShowLocat" :mapObj='mapObj'  @cMapClick="cMapClick"></LocatingInfo>

        
    </div>
</template>

<script>
import { 
    deviceListFind,
    deleteList,
    importNotAttendanceDevice,
    importAttendanceDevice,
    importTerminalDevice,
    deviceFind,
    familyNumberExport,
    deviceDataReport,
    menuGetUserTree,
    deviceUnbind,
    deviceRestart,
    deviceShutdown,
    piliangDevice,
    deviceRestartJnyong
} from '@/assets/api/api'
import { deviceLocate } from '@/assets/api/zhongduan'
import { ElMessage } from 'element-plus'
import Add from './group/add.vue';
import Huanjiadd from './group/Hanjiadd.vue';
import Delete from './group/delete.vue';
import userAreaDelete from '@/components/userArea/index.vue';
import Qiehuan from './group/Qiehuan.vue';
import { ArrowUp,ArrowDown } from "@element-plus/icons-vue"; // 图标
import MapInfo from './Dingwei/mapInfo.vue';
import LocatingInfo from './Dingwei/LocatingInfo.vue';
import {getButtonList} from "../../../../../assets/api/api";
export default {
    components: {
        Add,
        Huanjiadd,
        ArrowUp,
        ArrowDown,
        Delete,
        userAreaDelete,
        Qiehuan,
        MapInfo,
        LocatingInfo,
        getButtonList,
    },
    data() {
        return {
           
            HuanjiObj:{},
            HuanjiShow:false,
            loading:true,
            DeleteShow:false,
            AddShow: false,
            SwitchingShow:false,
            ShowMap:false,
            ShowLocat:false,
            currentPage3: 1,
            form:{
                outernetName:'',
                appVersion: '',
                bluetoothMac: '',
                deviceName: '',
                dictionaryName: '',
                imei: '',
                phoneNumber: '',
                rfid: '',
                toIP: ''
            },
            value:'',
            tableData: [],
            buttonData:[],
            multipleSelection: [],
            pageInfo: {
                page: 1,
                pageSize: 30,
            },
            total: 0,
            addressValueList: [
                {
                    name: '修改',
                    value: '1'
                },
                {
                    name: '删除',
                    value: '2'
                },
                // {
                //     name: '禁止',
                //     value: '3'
                // },
                // {
                //     name: '亲情号',
                //     value: '4'
                // },
                {
                    name: '换机',
                    value: '5'
                },
                {
                    name: '解除绑定',
                    value: '6'
                },

                // /device/immediatelyLocate
               
            ],
            formSourcesValue: '0',
            formSourcesList: [
                {
                    name: '新增终端',
                    value: '1'
                },
                {
                    name: '批量删除',
                    value: '12'
                },
                {
                    name: '导入非考勤数据',
                    value: '2'
                },
                {
                    name: '导入考勤数据',
                    value: '3'
                },
                {
                    name: '导入终端数据',
                    value: '5'
                },
              
                {
                    name: '导出数据报表',
                    value: '8'
                },
                {
                    name: '导出亲情号',
                    value: '9'
                },
                {
                    name: '下载非考勤数据模板',
                    value: '6'
                },
                {
                    name: '下载考勤数据模板',
                    value: '7'
                },
                         {
                    name: '下载终端数据模板',
                    value: '10'
                },
                {
                    name: '下载蓝牙数据模板',
                    value: '11'
                },
                {
                    name: '切换服务',
                    value: '4'
                },
            ],
            tempFile: "", //文件
            theuserValue: '',
            theuserList: [
                
            ],
            detailsObj: {},
            addressIndex: null,
            ArrowShow: true ,
            lastAckSort: '',
            treeData:[],
            twigMax: 0,
            twigMin: 0,
            userAreaDelete: false, // 区域弹框
            belongArea: '', // 区域下拉绑定
            belongAreaList: [], // 区域下拉绑定的数组
            mapObj:{},
            leadingAreaList: [],
            userAreaName:'',
            options: [{
                    value: 1,
                    label: '今日活跃'
                }, {
                    value: 2,
                    label: '7日活跃'
                },
                {
                    value: 3,
                    label: '今日激活'
                },
                {
                    value: 4,
                    label: '7日激活'
                }
            ],
            Tongji:""
        };
    },
    created() {

    },
    mounted() {
        this.searchClick()
        this.menuGetUserTreeGet()
        this.getButtonList()
        console.log('搜索', JSON.parse(localStorage.getItem('user')).id,localStorage.getItem('token'))
    },
    watch: {
        formSourcesValue (val) {
            console.log(val,'监听大下拉框');
            if (val == 1) {
                this.AddShow = true
            } else if (val == 9 || val == 8) {
                this.deriveFamily()
            } else if(val == 6){
                window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/非考勤数据.xls'
            } else if(val == 7){
                window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/考勤数据.xls'
            } else if(val == 10){
                window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/device.xls'
            } else if(val == 11){
                window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/蓝牙数据.xls'
            }else if(val == 4){
               console.log('切换');
            this.SwitchingShow = true
            }if(val == 12){
            //    this.closeClick()
            this.DeleteShow = true
               console.log('我是批量删除');
            }
            
            // this.ClearClick()

        },
    },
    methods: {
        //禁用
        jinYong(item){
            this.$confirm(item.disable ==  0?'是否确认禁用!':'是否确认启用!', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                     }).then(() => {
                    const status = item.disable ==  0 ? true : false

                    deviceRestartJnyong(item.deviceId,status).then((res) => {
                                // console.log(res,'禁用启用');
                            this.searchClick()
                
                                
                            })

                    }).catch((err) => {
                        console.log(err,'禁用启用');

                    });

            
        },
        // 定位信息
        locatingInfoC(row){
            this.mapObj = row
            this.ShowLocat = true
            console.log('定位信息');

            
        },
        //地图
        WeiZhi(row){
            // console.log('位置',row.imei);
            this.mapObj = row
            this.ShowMap = true
            
        },
        cMapClick(){
            this.ShowLocat = false
            this.ShowMap = false
            this.mapobj = {}
            this.searchClick()


        },
        visibleChange (value) {
            // console.log(1123);
            this.userAreaName = value
            this.userAreaDelete = true  
            if ( value == '导入' ) {
                this.$refs.selectTo.blur()
            } else if (value == '查询') {
                this.$refs.selectYi.blur()
            }
        },
        singleSelectionClick (item) {
            if ( this.userAreaName == '查询' ) {
                this.belongAreaList = [item]
                this.belongArea = item.id
                // this.inquiryClick()
            } else if( this.userAreaName == '导入' ){
                this.leadingAreaList = [item]
                this.theuserValue = item.id
            }
            this.userAreaDelete= false
            console.log(item,item.name,'单选');
        },
        handleClose () {
            this.userAreaDelete = false 
        },
        closeClick(){
            this.DeleteShow = false
            this.formSourcesValue = '0'
            // this.HuanjiObj = {}
            if ( this.addressIndex != null ) {
                this.tableData[this.addressIndex].addressValue = '0'
            }
            this.searchClick()
        },

        moren () {
            this.$message({
                message: '默认-顺序',
                type: 'success'
            }); 
            this.ArrowShow = true
            this.lastAckSort = null
            this.searchClick()
        },
        upwardClick () {
            this.$message({
                message: '切换-倒序',
                type: 'success'
            });
            console.log('向上');
            this.ArrowShow = false
            this.lastAckSort = 'desc'
            this.searchClick()
            
        },
        downwardClick() {
            console.log('向下');
            this.$message({
                message: '切换-正序',
                type: 'success'
            });
            this.ArrowShow = true
            this.lastAckSort = 'asc'
            this.searchClick()
        },
        menuGetUserTreeGet() {
            let params = {
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            menuGetUserTree(params).then((res)=> {
                console.log(res,res.data.data[0],'获取--所属用户下拉框');
                // this.regionList = [...res.data.data, ...res.data.data[0].children]
                this.arrayTreeAddLevel(res.data.data)
                // this.regionList = this.treeData
                // 数组倒序
                this.regionList = this.treeData.reverse()
                this.regionList.forEach( item => {
                item.label = item.alias ||item.siteName ||item.circleName ||item.username ||item.label
                item.value = item.id
                if ( item.children ) {
                    delete item.children;
                }
                })
                // this.regionList.sort();
                console.log(this.regionList);
                if ( JSON.stringify(this.detailsObj) != '{}' ) return console.log(JSON.parse(localStorage.getItem('user')));
                this.Dform.region = JSON.parse(localStorage.getItem('user')).id
            }).catch((err)=> {
                // console.log(err);
                this.$message({
						type: 'error',
						message: err.response.data.msg
					});
            })
        },
        AddShowClick () {
            console.log(22222);
            this.AddShow = false
            this.SwitchingShow = false
            this.formSourcesValue = '0'
            this.detailsObj = {}
            if ( this.addressIndex != null ) {
                this.tableData[this.addressIndex].addressValue = '0'
            }
            this.searchClick()
        },
        addressClick(item,index) {
            console.log(item,index,'下拉触发');
            this.addressIndex = index
            if (item.addressValue == 2) {
                if ( item.memberPhoneNumber != null && item.memberPhoneNumber != '' ) return this.$message({type: 'error',message: '当前终端正在使用中，不允许进行删除操作'});
                this.multipleSelection.push(item)
                this.$confirm('是否删除终端?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                     }).then(() => {
                         this.deleteClick()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }).catch((err) => {
                        console.log(err,'关机');
                        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
                    });

            } else if (item.addressValue == 1) {
                this.deviceFindClick(item)
            }else if (item.addressValue == 5) {
                //换机
                this.HuanjiClick(item)
            }
            else if (item.addressValue == 6) {
                //解绑
                this.removebindingClick(item)

            }else if (item.addressValue == 7) {
                //远程关机
                this.shutdownClick(item)
            }else if (item.addressValue == 8) {
                 //远程重启
                 this.restartClick(item)

            }else if (item.addressValue == 9) {
                 //终端设置
        //         this.$router.push({name: 'terminalStiing', 
        //             state: { 
        //             imei: item.imei,
        //             deviceName: item.deviceName,
        //             deviceId: item.deviceId,
        //             }
        //    })
                const routeUrl = this.$router.resolve({
                    path: '/zhongduan-setting',
                    query: {deviceId:item.deviceId,iemi: item.imei,name: item.deviceName},
                    // params:this.lnglatsItem
                })
            window.open(routeUrl.href, '_blank')
            }else if (item.addressValue == 10) {
                 //远程重启
                 this.dingwei(item)
                console.log('立即定位');
            }
            
        },
        //立即定位
        dingwei(item){
            const params ={
                imei:item.imei
                };
                deviceLocate(params).then((res)=> {
                this.$alert(res.data.msg, '操作提示', {
                confirmButtonText: '确定',
                });
                this.ClearClick()
            }).catch((err) => {
                this.$alert(err.response.data.msg, '操作提示', {
                confirmButtonText: '确定',
                });
                // this.ClearClick()

            })

      },
        // 远程重启
        restartClick(item){
            this.$confirm('请确定远程重启吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.restartRequest(item)
                        this.$message({
                            type: 'success',
                            message: '远程重启成功!'
                        });
                    }).catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
                    });
             
        },
        restartRequest(item){
            deviceRestart(item.imei).then((res)=> {
                console.log(res,'重启成功');
                this.ClearClick()
                
            }).catch((err) => {
                // console.log(err,'重启失败');
                this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });

            })
        },
        // 远程关机
        shutdownClick(item){
            this.$confirm('请确定远程关机吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.shutdownRequest(item)
                       
                    }).catch((err) => {
                        // console.log(err,'关机');
                        this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });
                     
                    });
        },
        shutdownRequest(item){
            deviceShutdown(item.imei).then((res)=> {
                // console.log(res,'关机成功');
                this.ClearClick()
                this.$message({
                            type: 'success',
                            message: '远程关机成功!'
                        });

            }).catch((err) => {
                // console.log(err,'关机失败');
                this.$message({
                            type: 'error',
                            message: err.response.data.msg
                        });

            })
        },
        //解除绑定
        removebindingClick(item){
            // console.log('我是解除绑定');
            this.$confirm('确定解除此终端绑定信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.jiebangClick(item)
                       
                    }).catch((err) => {
                        console.log(err);        
                      
                    });
                    },
        //解绑接口调用
        jiebangClick(item){
            console.log('接口调用',item);
            let userId = JSON.parse(localStorage.getItem('user')).id
            deviceUnbind(item.deviceId,item.memberId,userId).then((res)=> {
                // console.log('解绑成功',res);
               this.ClearClick()
               this.$message({
                            type: 'success',
                            message: '解除成功!'
                        });
                }).catch((err)=> {
                // console.log('解绑失败',err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

                })
        },
        //清除下拉框数据
        ClearClick(){
            this.formSourcesValue = '0'
                if ( this.addressIndex != null ) {
                    this.tableData[this.addressIndex].addressValue = '0'
                }
                this.searchClick()
        },

        //换机
        HuanjiClick(item){
            console.log('我是换机',item);
            this.HuanjiObj = item
            this.HuanjiShow = true
      
        },
        HuanjiShowClick(){
            this.HuanjiShow = false
            this.formSourcesValue = '0'
            if ( this.addressIndex != null ) {
                this.tableData[this.addressIndex].addressValue = '0'
            }
            this.searchClick()
        },

        deviceFindClick (item) {
            let params = {
                deviceId: item.deviceId 
            }
            deviceFind(params).then((res)=> {
                this.detailsObj = res.data
                this.AddShow = true
            }).catch((err)=> {
                console.log(err);
            })
        },
        sort_change ({ column }  ) {
            if ( column.order == 'ascending' ) {
                console.log('升序');
            } else if ( column.order =='descending' ){
                console.log('降序');
            }
            console.log(column, column.label,'排序');
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection,val,'this.multipleSelection');
        },
        deleteClick() {
            if( !this.multipleSelection.length) {
                ElMessage.error('请先选中需要删除的终端。')
            } else {
                let arr = []
                for(let value of  this.multipleSelection) {
                    console.log(value.deviceId,5555555);
                    arr.push(value.deviceId)
                }
                let params = {
                    userId: JSON.parse(localStorage.getItem('user')).id,
                    deviceIds:arr
                }
                deleteList(params).then((res)=> {
                    console.log(res,'删除接口');
                    // this.searchClick()
                    // ElMessage({message: '删除成功',type: 'success',})
                    this.multipleSelection = []
                    this.searchClick()
                }).catch((err)=> {
                    console.log(err);
                })
            }
        },
        searchSouSuoClick () {
            this.pageInfo.page = 1
            this.searchClick()
        },
        searchClick () {
            console.log('查询');
            this.loading = true
            let Id = null
            if ( this.belongAreaList.length && this.belongArea != '' ) {
                Id = this.belongArea
            } else {
                Id = JSON.parse(localStorage.getItem('user')).id
            }
            let params = {
                appVersion: this.form.appVersion,
                bluetoothMac: this.form.bluetoothMac,
                deviceName: this.form.deviceName,
                dictionaryName: this.form.dictionaryName,
                imei: this.form.imei,
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                phoneNumber: this.form.phoneNumber,
                rfidDecimal: this.form.rfid,
                toIP: this.form.toIP,
                userId: Id,
                lastAckSort: this.lastAckSort != ''? this.lastAckSort:'desc',
                type:this.Tongji,
                // lastAckSort:'desc'
            }
            deviceListFind(params).then((res)=> {
                console.log(res.data.list,'列表接口');
                // console.log('this', this)
                // this.$set(this.pageInfo,'addressValue','')
                if ( res.data.list ) {
                    for(let item of res.data.list ) {
                        item.addressValue = '0'
                        if ( item.memberPhoneNumber != null && item.memberPhoneNumber != '' ) {
                            item.addressValueList = [
                                {
                                    name: '修改',
                                    value: '1'
                                },
                                {
                                    name: '删除',
                                    value: '2'
                                },

                                // {
                                //     name: '亲情号',
                                //     value: '4'
                                // },
                                {
                                    name: '换机',
                                    value: '5'
                                },
                                
                                {
                                    name: '解除绑定',
                                    value: '6'
                                },
                                {
                                    name: '终端设置',
                                    value: '9'
                                },
                                {
                                    name: '远程重启',
                                    value: '8'
                                },
                              
                                {
                                    name: '远程关机',
                                    value: '7'
                                },
                                
                                {
                                    name: '立即定位',
                                    value: '10'
                                },
                            ]
                        } else {
                            item.addressValueList = [
                                {
                                    name: '修改',
                                    value: '1'
                                },
                                {
                                    name: '删除',
                                    value: '2'
                                },

                                // {
                                //     name: '亲情号',
                                //     value: '4'
                                // },
                                {
                                    name: '终端设置',
                                    value: '9'
                                },
                               
                                {
                                    name: '远程重启',
                                    value: '8'
                                },
                                {
                                    name: '远程关机',
                                    value: '7'
                                },
                              
                                {
                                    name: '立即定位',
                                    value: '10'
                                },
                            ]
                        }
                    }
                    this.tableData =  res.data.list 
                    this.total = res.data.total
                    this.loading = false
                    // console.log(this.pageInfo.pageSize*this.pageInfo.page,res.data.list.length,'111111111111');
                    let str = 0
                if ( res.data.list.length < 30 ) {
                  str = 30 - res.data.list.length
                }
                console.log(this.pageInfo.pageSize * this.pageInfo.page - 29,']]]]]',this.pageInfo.pageSize * this.pageInfo.page-str);
                this.twigMin = this.pageInfo.pageSize * this.pageInfo.page - 29
                this.twigMax = this.pageInfo.pageSize * this.pageInfo.page - str
        
                console.log(this.tableData,789789,this.total,res.data.total);;
                      }
            }).catch((err)=> {
                console.log(err);
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.searchClick()
        },
         // 上传
         uploadClick() {
            let index = this.tempFile.name.lastIndexOf(".");
            let fileName = this.tempFile.name.substr(index + 1);
            var filetypes = [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "doc",
                "ppt",
                "xls",
                "pdf",
                "docx",
                "xlsx",
            ];
            if (filetypes.includes(fileName)) {
                if (this.tempFile) {
                    let fileSize = this.tempFile.size / (1024 * 1024 * 60);
                    // if (fileSize > 1) {
                    //     this.$message.error({ message: "文件不能超过60M！" });
                    // } else {
                        if (this.tempFile.name) {
                            let formData = new FormData();
                            console.log(formData,8888888);
                            formData.append("file", this.tempFile);
                            console.log(this.tempFile,formData.getAll('file'));
                            if (this.formSourcesValue == '2') { 
                                importNotAttendanceDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res.data);
                                    this.handleExport(res.data,'考勤数据.xls')
                                    ElMessage({message: '非考勤数据上传成功',type: 'success',})

                                }).catch((err)=> {
                                    // console.log();
                                    // ElMessage.error("上传失败")
                                    ElMessage.error(err.response.data.msg || '导入失败')

                                })
                            } else if (this.formSourcesValue == 3) {
                                importAttendanceDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res.data,666666666666);
                                    ElMessage({message: '考勤数据上传成功',type: 'success',})
                                    this.handleExport(res.data,'考勤数据.xls')
                                }).catch((err)=> {
                                    // console.log(err.response.data.msg,1111);
                                    // ElMessage.error(err.response.data.msg)
                                    ElMessage.error(err.response.data.msg || '接口异常')

                                })
                            }else if (this.formSourcesValue == '5') {
                                importTerminalDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res);
                                    ElMessage({message: '终端数据上传成功',type: 'success',})
                                }).catch((err)=> {
                                    // console.log();
                                    // ElMessage.error("上传失败")
                                    // ElMessage.error(err.response.data.msg)
                                    ElMessage.error(err.response.data.msg || '接口异常')


                                })
                            }
                            
                        }
                    // }
                }
            } else {
                ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
            }
            
        },
        getFile(event) {
            this.tempFile = event.target.files[0];
        },
        deriveFamily (val) {
             let Id = null
            if ( this.belongAreaList.length && this.belongArea != '' ) {
                Id = this.belongArea
            } else {
                Id = JSON.parse(localStorage.getItem('user')).id
            }
            let params = {
                appVersion: this.form.appVersion,//版本号
                bluetoothMac: this.form.bluetoothMac, // 蓝牙MAC
                deviceName: this.form.deviceName, // 姓名
                dictionaryName: this.form.dictionaryName, // 型号
                imei: this.form.imei, // imei
                phoneNumber: this.form.phoneNumber, // 号码
                rfidDecimal: this.form.rfid, // rfid
                userId: Id,
                type:this.Tongji
            }
            if (this.formSourcesValue == 8) {
                deviceDataReport(params).then((res)=> {
                    this.handleExport(res.data,'数据报表.xls')
                }).catch((err)=> {
                    // ElMessage.error("导出数据报表失败")
                    ElMessage.error(err.response.data.msg)

                })
            } else if (this.formSourcesValue == 9) {
                familyNumberExport(params).then((res)=> {
                    this.handleExport(res.data,'亲情号.xls')
                }).catch((err)=> {
                    // ElMessage.error("导出亲情号失败")
                    ElMessage.error(err.response.data.msg)

                })
            }
        },
       
        handleExport(data,name) {
            // 动态创建iframe下载文件
            let fileName = name;
            if (!data) {
                return;
            }
            let blob = new Blob([data], { type: "application/octet-stream" });
            console.log(blob);
            if ("download" in document.createElement("a")) {
                // 不是IE浏览器
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 下载完成移除元素
                window.URL.revokeObjectURL(url); // 释放掉blob对象
            } else {
                // IE 10+
                window.navigator.msSaveBlob(blob, fileName);
            }
        },
        arrayTreeAddLevel (array, levelName = 'level', childrenName = 'children') {
              if (!Array.isArray(array)) return []
                       const recursive = (array, level = 0) => {
                       level++
                       return array.map(v => {
                            v[levelName] = ''
                       // for( let value     )
                       for (var i = 0; i < level; i++){
                                     v[levelName] = v[levelName] + ' ——'
                       }
                       // level.forEach(item=> {
                       // })
                       const child = v[childrenName]
                       if (child && child.length) recursive(child, level)
                            return this.treeData.push(v) 
                       })
                       }
              return recursive(array)
              },

      getButtonList(){
        const params = {
          userId: JSON.parse(localStorage.getItem('user')).id,
          menuName:"终端管理",
        }
        getButtonList(params).then((res)=>{
          this.buttonData = res.data.data;
          console.log(res,'按钮权限');
        }).catch((err=>{
          console.log(err,'按钮异常');
          this.$message({
            type:'error',
            message:'获取按钮异常，请重试'
          })
        }))
      },
    },
};
</script>

<style scoped lang="scss" >


.campus-announcement {
    height:  96%;
    background-color: #fff;
    .Input-Row-Top{
        height: 180px ;
        background-color: #fff;
        padding-top:10px;
        border-radius: 8px;
        
    .shebeigunali{
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 700;
        margin-left: 20px;
    }
    .searchBtn{
        // background-color: #1BC896;
    }

    /deep/{

.el-select-dropdown__list {
    max-height: 200px !important; 
    overflow: auto  !important;
    z-index:999999999

}
.selectStyle{
    max-height: 200px !important; 
    overflow: auto  !important;
    z-index:999999999
}
}
    /deep/ {
         .el-select-dropdown__wrap.el-scrollbar__wrap {
  overflow: auto;
}
        .el-col-6{
            margin-top: 30px;
            max-width: 17%;
            // margin-right: 40px;
        }
        .el-input--small .el-input__wrapper{
          width: 10px;
          text-align: right;
          height: 35px;
          line-height: 35px;        
        }
        .el-form-item--small .el-form-item__label{
            margin-left: 20px;
            line-height: 35px;
            font-weight: 700;
            font-size: 16px;
        }
        .el-input--small .el-input__inner {
            width: 30px;
        }
        .el-button--medium{
            margin-top: 30px;
            margin-left: 60px;
        }
        .el-input--small .el-input__wrapper{
            width: 160px !important;
        }
        .el-select--small .el-select__wrapper{
            height: 35px;
            // widt8h: 200px;
            max-width: 250px !important;
            
        }
    }

  
  }
  .Table-Bottom{
    height: calc(100% - 250px);
    // height: 100%%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 16px;
    // margin-top: 15px;
    border-radius: 8px;
    .jilumes{
        text-align: left;

    }
        /deep/{
            .el-table_1_column_3 {
                // width: 300px !important;
                // color: pink !important;
            }

         .el-table tr {
            font-size: 16px;
            height: 40px !important;
            color: black;
            
        }
        .el-table--small .cell{
            text-align: center;
        }
        .textBtn{
            padding: 0px !important; 
            font-size: 16px;
            // color: black;
            margin-left: 0px;
            margin-right: 5px;
        }
        .el-table td.el-table__cell div{
        }
        }
}

.block{
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 15px;
    .sorter{
        margin-left: 50px;
    }
    .total{
        padding-top: 5px;
        margin-left: 800px;

    }
    .texttiao{
        color: #459FFC;
        
    }
}
.shanchu {
    margin-top: 15px;
    margin-left: 25px !important;
}
.upload-box {
    margin-top: 15px;
    .upload-lef {
        margin-left: 20px;
        font-size: 14px;
        .upload-title {}
    }
    /deep/ {
        .el-select--small .el-select__wrapper{
            height: 35px;
            width: 200px;
            
        }
   
        .el-table--border .el-table__cell {
            text-align: center;
        }
        .el-table--enable-row-transition .el-table__body td.el-table__cell{
                    font-size: 40px;
                    font-weight: 700;
                    // border:none !important;
                    
        }
            .el-select .el-input__inner {
                height: 35px;
            }
            .el-form-item--small .el-form-item__label{
                margin-left: 20px;
                line-height: 35px;
                color: black;
            }
            
            .el-upload-list {
                // dis
                font-size: 80px;
            }

            
        }
    }
}
</style>
<style>
.el-select-dropdown__list {
    max-height: 250px !important; 
    overflow: auto  !important;

}
</style>
